import React from 'react';

import KeyWords from './KeyWords'

import {useRouter} from 'next/router'
export default function KeyWordsHelpers(props) {
  return (
    <>

     {<KeyWords
        
  
        />}
        
    </>
  );
}
